import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";


const ContactUs: React.FC = () => {
  return (
    <section className="py-5 text-white">
      <Container>
        {/* Heading */}
        <Row className="mb-4">
          <Col>
            <h1 className="fw-bold">Get in Touch with Bartollini Pizza</h1>
            <p className="text-white-75 mb-0">
              Planning an event or visiting our Galway location? We’d love to hear from you!
            </p>
          </Col>
        </Row>

        <Row className="g-4 align-items-stretch">
          {/* Contact details (glass card) */}
          <Col md={6}>
            <Card className="h-100 shadow-sm bg-custom-dark text-white border-secondary rounded-4">
              <Card.Body className="p-4">
                <section aria-labelledby="contact-details">
                  <h2 id="contact-details" className="h4 fw-semibold mb-3">
                    Contact Details
                  </h2>

                  <ul className="list-unstyled mb-4">
                    <li className="d-flex align-items-start mb-3">
                      <span className="me-3 fs-4" aria-hidden>📍</span>
                      <div>
                        <strong>Address</strong>
                        <br />
                        <a
                          className="text-decoration-none text-white"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.google.com/maps/place/Bartollini+Pizza/@53.2904879,-9.0122006,17z"
                        >
                          Ballybrit, Galway, H91 WC5P, Ireland
                        </a>
                      </div>
                    </li>

                    <li className="d-flex align-items-start mb-3">
                      <span className="me-3 fs-4" aria-hidden>📞</span>
                      <div>
                        <strong>Preorder / Contact</strong>
                        <br />
                        <a
                          href="tel:+353892063068"
                          className="text-decoration-none text-white"
                        >
                          089 206 3068
                        </a>
                      </div>
                    </li>

                    <li className="d-flex align-items-start mb-3">
                      <span className="me-3 fs-4" aria-hidden>📧</span>
                      <div>
                        <strong>Email</strong>
                        <br />
                        <a
                          href="mailto:bartollinipizza@gmail.com"
                          className="text-decoration-none text-white"
                        >
                          bartollinipizza@gmail.com
                        </a>
                      </div>
                    </li>
                  </ul>

                  <div className="pt-2 border-top border-secondary">
                    <h3 className="h6 fw-semibold mb-2">Opening Hours</h3>
                    <ul className="mb-0 text-white-75">
                      <li>Mon – Tue: Closed</li>
                      <li>Wed – Fri: 12:00 PM – 09:00 PM</li>
                      <li>Weekend: Check our socials</li>
                    </ul>
                  </div>
                </section>
              </Card.Body>
            </Card>
          </Col>

          {/* Map panel (image only, rounded) */}
          <Col md={6}>
            <div className="h-100 rounded-4 overflow-hidden shadow-sm">
              <iframe
                title="Bartollini Pizza Location"
                width="100%"
                height="100%"
                style={{ minHeight: "400px", border: 0 }}
                src="https://maps.google.com/maps?q=53.2904847,-9.0096257&z=17&output=embed"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactUs;
